import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import API from "./api";

export default function ProtectedRouteUser({ children }) {

  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {

    const checkAuth = async () => {
      try {
        const res = await API.get("/user/profile.php", {
          withCredentials: true
        });

        if (res.data.status === "login_required") {
          setIsAuth(false);
        } else {
          setIsAuth(true);
        }

      } catch (err) {
        setIsAuth(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();

  }, []);

  if (loading) return <div style={{padding:40}}>Checking login...</div>;

  if (!isAuth) return <Navigate to="/login" replace />;

  return children;
}